// extracted by mini-css-extract-plugin
export default {"search":"_21ire","animatedPlaceholder":"_1DxBx"};